module.exports = __webpack_public_path__ + "images/newerp_icon3.1792570018885.png";